import { type UseQueryResult, useQuery } from 'react-query';
import {
  PsuAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_AdminPsuDashboardGrantList,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetPsuViewTableList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  grantId: string,
  vestingDate: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_AdminPsuDashboardGrantList | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const psuViewTableList = useQuery(
    ['getPsuViewTableList', tableInfo, grantId, vestingDate],
    async () => {
      return await handleRequest(
        PsuAwardService.getApiAwardApiAppPSUAwardAdminDashboardGrantList(
          vestingDate,
          grantId,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return psuViewTableList;
};

export default useGetPsuViewTableList;
